/**
 * Search URL builders for recommendation CTAs (Milestone 13).
 */
import { runtimeVehicleSearchPath } from "../clientViewRuntime/utils/routes";
import { serializeVehicleSearchParams } from "./vehicleSearch/vehicleSearchParamsUrl";

function cleanParams(params) {
  const next = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    if (Array.isArray(value) && !value.length) return;
    next[key] = value;
  });
  return next;
}

export function buildSearchHrefFromListing(listing, options = {}) {
  const slug = options.slug || "automap";
  const basePath = options.basePath || runtimeVehicleSearchPath(slug);
  const priceCop = listing?.priceCop != null ? Number(listing.priceCop) : null;

  const params = cleanParams({
    city: listing?.city || null,
    make: listing?.make || null,
    model: listing?.model || null,
    bodyType: listing?.bodyType || null,
    yearMin: listing?.year ? Number(listing.year) - 3 : null,
    yearMax: listing?.year ? Number(listing.year) + 3 : null,
    priceMinCop: priceCop != null ? Math.round(priceCop * 0.75) : null,
    priceMaxCop: priceCop != null ? Math.round(priceCop * 1.25) : null,
    sort: options.sort || "best_value",
    page: 1,
  });

  const qs = serializeVehicleSearchParams(params).toString();
  return qs ? `${basePath}?${qs}` : basePath;
}

export function getSimilarVehiclesSearchHref(listing, options = {}) {
  if (options.sectionKey === "similar_body_type" && listing?.bodyType) {
    return buildSearchHrefFromListing(
      { ...listing, make: null, model: null },
      { ...options, sort: "best_value" }
    );
  }
  if (options.sectionKey === "similar_budget") {
    return buildSearchHrefFromListing(
      { ...listing, make: null, model: null, bodyType: null },
      options
    );
  }
  return buildSearchHrefFromListing(listing, options);
}
